import { Directus } from '@directus/sdk'
import { CustomDirectusTypes } from 'types/directus'

export type EventDate = {
  day: string
  from: string
  to: string
}

// Check if value is type of EventDate
export function isEventDate(value: unknown): value is EventDate {
  return (
    typeof value === 'object' &&
    value !== null &&
    'day' in value &&
    'from' in value &&
    'to' in value
  )
}

// Check if value is type of EventDate[]
export function isEventDateArray(value: unknown): value is EventDate[] {
  return Array.isArray(value) && value.every((item) => isEventDate(item))
}

const directus = new Directus<CustomDirectusTypes>(process.env.GATSBY_DIRECTUS)
export { directus }
